'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _constants = require('../constants');

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _style = require('../style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyframeSlideDown = function keyframeSlideDown(_ref) {
  var size = _ref.size;
  return {
    '0%': {
      transform: 'translateY(' + size + ')'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  };
};

var keyframeOpacityIn = function keyframeOpacityIn() {
  return {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  };
};

var wrapper = function wrapper(_ref2) {
  var inScroll = _ref2.inScroll,
      mobile = _ref2.mobile;
  return _extends({
    position: inScroll ? 'fixed' : 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    fontWeight: 'normal',
    lineHeight: 'normal',
    zIndex: 1030,
    transition: 'top 0.2s ease-in-out',
    willChange: 'top',
    boxShadow: inScroll ? '0 2px 4px 0 rgba(0, 0, 0, 0.1)' : 'none'
  }, !mobile && {
    animationDuration: '0.3s',
    animationName: _style.renderer.renderKeyframe(inScroll ? keyframeSlideDown : keyframeOpacityIn, { size: '-200px' })
  });
};

var Wrapper = (0, _preactFela.createComponent)(wrapper);

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref3, [this].concat(args))), _this), _this.delta = 5, _this.lastScrollTop = window.scrollY, _this.state = {
      mobile: window.matchMedia('(max-width: ' + _constants.BREAKPOINT.DESKTOP + ')').matches,
      inScroll: _this.lastScrollTop > 104,
      windowHeight: window.innerHeight * 0.8
    }, _this.handleMedia = function (_ref4) {
      var matches = _ref4.matches;

      _this.setState({ mobile: matches });
    }, _this.handleScroll = function () {
      var scrollY = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;
      var inScroll = scrollY > 104;

      if (_this.state.inScroll && !inScroll) {
        _this.setState({ inScroll: false });
      } else if (!_this.state.inScroll && inScroll) {
        _this.setState({ inScroll: true });
      }
    }, _this.handleResize = function () {
      _this.setState({ windowHeight: window.innerHeight * 0.8 });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var media = window.matchMedia('(max-width: ' + _constants.BREAKPOINT.DESKTOP + ')');
      media.addListener(this.handleMedia);

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        Wrapper,
        { inScroll: this.state.inScroll },
        (0, _preact.h)(_Header2.default, this.state)
      );
    }
  }]);

  return Container;
}(_preact.Component);

exports.default = Container;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Container.js
// module id = 182
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38